import React, {Component} from 'react'
import '../../../../../styles/Wyszukiwarka.css'
import Select from 'react-select'
import {Button, Col} from "react-bootstrap";
import BiletyMiesieczneService from "./../BiletyMiesieczneService";
import KoszykService from "../../../../../koszyk/KoszykService";
import * as acc from "accounting";
import FirmyFormComponent from "../FirmyFormComponent";

export default class DoladowanieKarty extends Component {

    constructor(props) {
        super(props);
        this.state = {
            lata: [
                {value: new Date().getFullYear(), label: new Date().getFullYear()},
                {value: new Date().getFullYear() + 1, label: new Date().getFullYear() + 1}
            ],
            rok: {value: new Date().getFullYear(), label: new Date().getFullYear()},
            miesiace: [],
            miesiaceList: [
                {value: 1, label: 'styczeń'},
                {value: 2, label: 'luty'},
                {value: 3, label: 'marzec'},
                {value: 4, label: 'kwiecień'},
                {value: 5, label: 'maj'},
                {value: 6, label: 'czerwiec'},
                {value: 7, label: 'lipiec'},
                {value: 8, label: 'sierpień'},
                {value: 9, label: 'wrzesień'},
                {value: 10, label: 'październik'},
                {value: 11, label: 'listopad'},
                {value: 12, label: 'grudzień'}
            ],
            miesiac: new Date().getMonth() + 1,
            miesiacValue: new Date().getMonth() + 1,
            uwagi: '',
            firmaDoFaktury: null,
            fakturaVat: false,
            dodajFirme: false,
            disabled: true,
            cena: ''
        };

        this.onChangeRok = this.onChangeRok.bind(this);
        this.onChangeMiesiac = this.onChangeMiesiac.bind(this);
        this.onChangeUwagi = this.onChangeUwagi.bind(this);
        this.onChangeFirmaDoFaktury = this.onChangeFirmaDoFaktury.bind(this);
        this.onClickZapiszFirme = this.onClickZapiszFirme.bind(this)
    }

    getMiesiace() {
        let miesiace = [];
        let lata = [];
        if (new Date().getDate() <= 25) {
            if (new Date().getMonth() + 1 === 12) {
                lata = [{
                    value: new Date().getFullYear() + 1,
                    label: new Date().getFullYear() + 1
                }, {value: new Date().getFullYear() + 2, label: new Date().getFullYear() + 2}];
                miesiace = this.state.miesiaceList;
            } else {
                lata = [{
                    value: new Date().getFullYear(),
                    label: new Date().getFullYear()
                }, {value: new Date().getFullYear() + 1, label: new Date().getFullYear() + 1}];
                for (let i = new Date().getMonth() + 1; i < this.state.miesiaceList.length; i++) {
                    miesiace.push(this.state.miesiaceList[i])
                }
            }
        } else {
            if (new Date().getMonth() + 2 === 12) {
                lata = [{
                    value: new Date().getFullYear() + 1,
                    label: new Date().getFullYear() + 1
                }, {value: new Date().getFullYear() + 2, label: new Date().getFullYear() + 2}];
                miesiace = this.state.miesiaceList;
            } else {
                if (new Date().getMonth() + 1 === 12) {
                    lata = [{
                        value: new Date().getFullYear() + 1,
                        label: new Date().getFullYear() + 1
                    }, {value: new Date().getFullYear() + 2, label: new Date().getFullYear() + 2}];
                    for (let i = 1; i < this.state.miesiaceList.length; i++) {
                        miesiace.push(this.state.miesiaceList[i])
                    }
                } else {
                    lata = [{
                        value: new Date().getFullYear(),
                        label: new Date().getFullYear()
                    }, {value: new Date().getFullYear() + 1, label: new Date().getFullYear() + 1}];
                    for (let i = new Date().getMonth() + 2; i < this.state.miesiaceList.length; i++) {
                        miesiace.push(this.state.miesiaceList[i])
                    }
                }
            }
        }
        this.setState({
            miesiace: miesiace,
            lata: lata,
            miesiac: miesiace[0],
            miesiacValue: miesiace[0].value,
            rok: lata[0]
        })
    }

    componentWillMount() {
        this.getMiesiace();
        BiletyMiesieczneService.getZnizkiMiesieczne((this.state.rok.value + '-' + (this.state.miesiacValue + 1) + '-01'), this.props.item.idMiOd, this.props.item.idMiDo, this.props.item.idTr, this.props.item.kierunek, this.props.item.okres)
            .then(function (response) {
                let res = response.data;
                for (let i = 0; i < res.length; i++) {
                    if (res[i].rodz === this.props.item.rodz) {
                        this.setState({cena: res[i].cena})
                    }
                }
            }.bind(this))
    }

    onChangeRok(e) {
        if (e.value === new Date().getFullYear()) {
            this.getMiesiace();
            this.getZnizki(e.value, (new Date().getMonth() + 2))
        } else {
            this.setState({rok: e, miesiace: this.state.miesiaceList, miesiac: this.state.miesiaceList[0], typ: ''});
            this.getZnizki(e.value, this.state.miesiaceList[0].value)
        }
    }

    onChangeMiesiac(e) {
        this.setState({miesiac: e, typ: '', miesiacValue: e.value});
        this.getZnizki(this.state.rok.value, e.value)
    }

    onChangeUwagi(e) {
        this.setState({uwagi: e.target.value})
    }

    onChangeFirmaDoFaktury(e) {
        this.setState({
            firmaDoFaktury: e
        })
    }

    zlozWniosek() {
        let idFi = null;
        if (this.state.firmaDoFaktury !== null) {
            idFi = this.state.firmaDoFaktury.idFi
        }
        BiletyMiesieczneService.postMiesieczny(this.state.cena, this.props.item, this.state.miesiacValue, this.state.rok.value, this.state.uwagi, idFi)
            .then((response) => {
                KoszykService.goPlatnosciMiesieczne(JSON.parse(sessionStorage.getItem('loggedIn')).login, response.data.platnosciTransakcja, this.state.cena, this.props.item.imieKl + ' ' + this.props.item.nazKl, this.props.item.telefonKl).then((response) => {
                    sessionStorage.setItem('platnosc', response.data);
                    window.location.replace(response.data);
                })
            })
    }

    getZnizki(rok, miesiac) {
        BiletyMiesieczneService.getZnizkiMiesieczne((rok + '-' + miesiac + '-01'), this.props.item.idMiOd, this.props.item.idMiDo, this.props.item.idTr, this.props.item.kierunek, this.props.item.okres)
            .then(function (response) {
                let res = response.data;
                for (let i = 0; i < res.length; i++) {
                    if (res[i].rodz === this.props.item.rodz) {
                        this.setState({cena: res[i].cena})
                    }
                }
            }.bind(this))
    }

    onClickZapiszFirme(obj, czyEdycja) {
        if (czyEdycja) {
            BiletyMiesieczneService.editFirma(this.state.firmaDoFaktury.idFi, obj).then(function (response) {

                let obiekt = this.state.firmaDoFaktury;
                obiekt['nazwa'] = obj.nazwa;
                obiekt['kodPocztowy'] = obj.kodPocztowy;
                obiekt['regon'] = obj.regon;
                obiekt['miejscowosc'] = obj.miejscowosc;
                obiekt['nrLokalu'] = obj.nrLokalu;
                obiekt['nrNieruchomosci'] = obj.nrNieruchomosci;
                obiekt['ulica'] = obj.ulica;
                obiekt['wojewodztwo'] = obj.wojewodztwo;
                obiekt['informacje'] = obj.nip + ' ' + obj.nazwa;

                this.setState({
                    firmaDoFaktury: obiekt,
                    dodajFirme: false
                })

            }.bind(this))
        } else {
            BiletyMiesieczneService.addFirma(obj).then(function (response) {
                if (response) {
                    if (response.data) {
                        this.setState({
                            firmaDoFaktury: Object.assign(response.data, {informacje: response.data.nip + ' ' + response.data.nazwa}),
                            dodajFirme: false
                        })
                    }
                }
            }.bind(this))

        }
    }

    getCompanies(input) {
        if (!input) {
            return Promise.resolve({options: []})
        }

        return BiletyMiesieczneService.szukajFirmePoNipieAlboPoNazwie(input).then(function (response) {

            let arr = Array.from(response.data.content, item => {
                return {
                    ...item,
                    informacje: item.nip + ' ' + item.nazwa,
                }
            });
            return {options: arr}
        }.bind(this))
    }

    renderFirmaOption(option) {
        return (
            <div><span className={'label'} title={'NIP'}>{option.nip}</span> {option.nazwa}</div>)
    }

    render() {
        return <div className="container miesieczne">
            <div>
                <div className="row" style={{paddingTop: 10}}>
                    <div className="col-sm-3">
                        Rok:
                        <Select
                            onChange={this.onChangeRok}
                            options={this.state.lata}
                            value={this.state.rok}
                            matchPos="start"
                            clearable={false}
                        />
                    </div>
                    <div className="col-sm-6">
                        Miesiąc:
                        <Select
                            onChange={this.onChangeMiesiac}
                            options={this.state.miesiace}
                            value={this.state.miesiac}
                            placeholder="Wybierz miesiąc"
                            matchPos="start"
                            clearable={false}
                        />
                    </div>
                    <div className="col-sm-3">
                        Cena:
                        <div className="cenaKarta">{acc.formatMoney(this.state.cena, {
                            symbol: "zł",
                            format: "%v %s"
                        })}</div>
                    </div>
                </div>
                <div className="row" style={{paddingTop: 10}}>
                    <div className="col-sm-12">
                        Uwagi:
                        <input type="text" value={this.state.uwagi} onChange={this.onChangeUwagi}
                               className="form-control"/>
                    </div>
                </div>
                <div className="row" style={{paddingTop: 20}}>
                    <div className="col-sm-3">
                        <input type={"checkbox"} onChange={() => this.setState({
                            fakturaVat: !this.state.fakturaVat,
                            firmaDoFaktury: null,
                            dodajFirme: false
                        })}
                               value={this.state.fakturaVat}/> Faktura VAT
                    </div>
                    <div className="col-sm-9 text-right">
                        <Button bsStyle='success'
                                onClick={() => this.zlozWniosek()}>Zapłać</Button>
                    </div>
                </div>
                {this.state.fakturaVat && !this.state.dodajFirme ? <div style={{marginTop: 25}}>
                    <Col xs={4}>
                        <Select.Async value={this.state.firmaDoFaktury} onChange={this.onChangeFirmaDoFaktury}
                                      valueKey="idFi"
                                      labelKey="informacje" loadOptions={this.getCompanies} clearable={false}
                                      backspaceRemoves={true}
                                      placeholder={'Wyszukaj firmę po NIP lub po nazwie'}
                                      loadingMessage={'Ładowanie...'}
                                      valueRenderer={(option) => this.renderFirmaOption(option)}
                                      optionRenderer={(option) => this.renderFirmaOption(option)}
                                      ignoreAccents={false}
                                      noResultsText={<div>Brak wyników <Button bsStyle={'success'}
                                                                               onClick={() => this.setState({dodajFirme: true})}
                                                                               text={'Dodaj nową firmę'}
                                                                               bsSize={'small'}>Dodaj firmę</Button>
                                      </div>}
                        />
                    </Col>
                </div> : <div>
                    {this.state.dodajFirme ? <FirmyFormComponent
                        edytowanaFirma={this.state.firmaDoFaktury}
                        handleClickAnuluj={() => {
                            this.setState({dodajFirme: false})
                        }}
                        handleClickZapisz={this.onClickZapiszFirme}
                    /> : null}
                </div>}

                {
                    (Boolean(this.state.firmaDoFaktury) && this.state.fakturaVat && !this.state.dodajFirme) ?
                        <div>
                            <hr/>
                            <div className="row">
                                <div className={'col-lg-12 text-center:'} style={{padding: '15px'}}>
                                    <h5 style={{marginBottom: '5px'}}>Firma, na którą zostanie wystawiona
                                        faktura:</h5>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-4">
                                    <h5 style={{color: 'grey'}}>Dane
                                        podstawowe</h5>
                                    <div style={{marginTop: 5}}>
                                        <label>Nazwa:</label> {this.state.firmaDoFaktury.nazwa}
                                    </div>
                                    <div><label>NIP:</label> {this.state.firmaDoFaktury.nip}
                                    </div>
                                    {
                                        Boolean(this.state.firmaDoFaktury.regon) ?
                                            <div>
                                                <label>REGON:</label> {this.state.firmaDoFaktury.regon}
                                            </div>
                                            :
                                            ''
                                    }
                                </div>
                                <div className="col-lg-4">
                                    <h5 style={{
                                        color: 'grey'
                                    }}>Adres</h5>
                                    <div style={{marginTop: 5, lineHeight: '32px'}}>
                                        {Boolean(this.state.firmaDoFaktury.ulica) ? this.state.firmaDoFaktury.ulica : ''} {Boolean(this.state.firmaDoFaktury.nrNieruchomosci) ? this.state.firmaDoFaktury.nrNieruchomosci : ''}{Boolean(this.state.firmaDoFaktury.nrLokalu) ? '/' + this.state.firmaDoFaktury.nrLokalu : ''}
                                    </div>
                                    <div>
                                        {Boolean(this.state.firmaDoFaktury.kodPocztowy) ? this.state.firmaDoFaktury.kodPocztowy : ''} {this.state.firmaDoFaktury.miejscowosc}{Boolean(this.state.firmaDoFaktury.wojewodztwo) ? ', ' + this.state.firmaDoFaktury.wojewodztwo : ''}
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <Button
                                        onClick={() => this.setState({dodajFirme: true})}
                                        titleContent={'Edytuj dane firmy'}
                                        style={{background: '#ffc107', color: '#fff'}}>Edytuj</Button>
                                </div>
                            </div>
                        </div>
                        :
                        ''
                }
            </div>
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/konto/panel/panelComponents/mojeBiletyComponents/szczegolyKartyComponents/DoladowanieKarty.js